import * as ApiConstants from '../constants/ApiConstants';
import { API } from '../constants/ServiceMSGConstants';
import { fetchGet } from '../utilities/ServiceUtils';

export const getPublicMeetingUrl = (bookingId) => {
    return `${ApiConstants.SERVICE_BOOKING}/${bookingId}`;
};
export const getPublicMeetingBookingDetail = (bookingId) => {
    return `${ApiConstants.SERVICE_BOOKING_DETAIL}/${bookingId}`;
};

export const getPublicMeetingById = async (bookingId) => {
    try {
        const url = `${getPublicMeetingBookingDetail(bookingId)}/public`;

        const response = await fetchGet(url);

        if (!response.ok) {
            const error = new Error('API Error');
            error.status = response.status;
            throw error;
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(API.GET_PUBLIC_MEETING_ERROR, error);
        throw error;
    }
};

export const postMeeting = async (meetingData, bookingId) => {
    try {
        const url = `${getPublicMeetingUrl(bookingId)}/checkin/external`;

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': 'th',
                'x-api-key': process.env.REACT_APP_API_KEY,
            },
            body: JSON.stringify(meetingData),
        });

        const responseData = await response.json();

        if (!response.ok) {
            const error = new Error('API Error');
            error.status = response.status;
            error.details = responseData.errors || [];
            throw error;
        }

        return responseData;
    } catch (error) {
        console.error(API.POST_MEETING_ERROR, error);

        if (error.status === 400 && error.details.length) {
            console.warn('400 Bad Request:', error.details);
            throw new Error(error.details[0].title || 'Bad Request');
        }

        throw error;
    }
};
